module.exports = __webpack_public_path__ + "media/img/pages/profile/fenaco ger 2-9a734d969cf0a14fead8624762ca71f7.jpg";